<template>
  <!-- <b-card> -->
    <b-row class="moneda">
      <b-col xl="6">
        <b-form-group
          label="Moneda"
          label-for="moneda"
          :label-cols="2"
          horizontal>
          <b-form-select 
            v-model="monedaNombre" 
            :options="monedasList" 
            class="mb-3">
            <template slot="first">
              <option :value="null" disabled>Seleccione una moneda</option>
            </template>
          </b-form-select>                 
        </b-form-group>

        <b-form-group
          label="Cotización"
          label-for="cotizacion"
          :label-cols="2"
          horizontal>
          <b-form-input 
            id="cotizacion"
            v-model.trim= "$v.cotizacion.$model" 
            :state="cotizacionValido"
            type="text"
            @blur.native="validate"
            :readonly="cotizacionReadOnly">
          </b-form-input>
          <b-form-invalid-feedback id="cotizacionFeedback">
            {{ cotizacionInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </b-col>
    </b-row>
  <!-- </b-card> -->
</template>

<script>
import { decimal, minValue } from 'vuelidate/lib/validators';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'compra/getField',
  mutationType: 'compra/updateField',
});

export default {
  name: 'ABMMoneda',
  components: {
  },
  props: {
    noValidar: {
      type: Boolean,
      default: false,
    },
    monedas: {
      type: Array,
      default: null
    },
    monedasList: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      cotizacionReadOnly: true,
      
      cotizacionValido: null,
      cotizacionInvalidoMsj: '',
    }
  },
  computed: {
    ...mapFields([
      'moneda',
      'monedaNombre',
      'cotizacion',
    ]),
  },
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
    },
  },
  validations: {
    cotizacion: { decimal, minValue: minValue(0) },
  },  
  watch: {
    'monedaNombre' : function(newVal, oldVal) {
      for ( let key in this.monedas ){
        const moneda = this.monedas[key]
        if (moneda.nombre.trim() == newVal.trim() ){
          
          this.$store.dispatch('compra/setMoneda', moneda)
          
          if (moneda.id == 101) {
            this.cotizacionReadOnly = true
            this.cotizacion = 1
          } else {
            this.cotizacionReadOnly = false
          }

          this.monedaValida = null;
          this.monedaInvalidaMsj = '';
        }
      }
    },
    'cotizacion' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularTotalOrdenes')
    },    
  },
}
</script>

<style>
  .compras-abm .moneda {
    margin-bottom: 30px;
  }
</style>
